module.exports = __webpack_public_path__ + "static/img/Freshfields.ee677f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/home-page-logos/Freshfields.png
// module id = HoSV
// module chunks = 0